// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tbIno","content":"styles_content__11JAb"};